// extracted by mini-css-extract-plugin
export default {"container":"WarningCard_container__Fi0DC"};